export const items = [
    {
        key: 'info',
        label: 'Info',
    },
    {
        key: 'access',
        label: 'Access',
    },
    {
        key: 'history',
        label: 'History',
    },
];


export const titleHead = {
    "all-documents": "All documents",
    "i-manage-responsible": "I'm responsible",
    "i-manage-assigned": "I'm assigned",
    "i-manage-assigned-others": "I assigned others",
    "role-owner": "Owner",
    "role-responsible": "Responsible",
    "role-editor": "Editor",
    "role-viewer": "Viewer",
    "archive": "Archive",
    "access-requests-to-me": "To me",
    "access-requests-from-me": "From me"
}

export const customFieldRequestForm = {
    title: "",
    document_type_id: "",
    document_type_title: "",
    context_of_use : "",
    variations: "",
    priority: "",
}

export const accessRequestForm = {
    role_id: 3,
    comment: ''
}

export const requestAccessObj = {
    document_id: null,
    requester_id: null,
    requester_email: null,
    access_form: false,
    access_form_modal: false,
    access_accept_access_mode: 'request',
    access_form_mode: 'createNew',
}

export const statusObj = {
    pending: "processing",
    rejected: "error",
    approved: "success"
}

export const duplicatesModal = {
    state: false,
    found: []
}